import { InvitePersonForm } from 'modules/components/layer12';
import { BasicFormModalLayout } from 'modules/components/layer13';
import React from 'react';
import { useParams } from 'react-router-dom';



export type InvitePersonModalProps = {
  id: string;
  isVisible: boolean;
  handleClose: () => void;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: InvitePersonModalProps) => {
  const params = useParams();
  return (
    <BasicFormModalLayout.FC
      id=''
      title='Invite User'
      subTitle='Enter the user email you want to invite'

      handleClose={props.handleClose}
      isVisible={props.isVisible}
    >
      <InvitePersonForm.FC
        projectId={params.projectId ?? ''}
        handleClose={props.handleClose}
      />

    </BasicFormModalLayout.FC>
  );
};
